var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconWifi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      background: "#fff"
    }
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h32v32H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: props.color
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.545 11.51L2.13 10.098A19.485 19.485 0 0116 4.352c5.239 0 10.164 2.04 13.868 5.745l-1.413 1.414A17.498 17.498 0 0016 6.35a17.499 17.499 0 00-12.457 5.16"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.544 15.422c-4.711-4.711-12.377-4.711-17.088 0l-1.414-1.414c5.49-5.489 14.424-5.491 19.916 0l-1.414 1.414zM20.526 19.441A6.358 6.358 0 0016 17.566c-1.71 0-3.317.666-4.526 1.875l-1.414-1.414a8.345 8.345 0 015.94-2.46c2.243 0 4.353.873 5.938 2.46l-1.413 1.414zM18.682 23.967a2.682 2.682 0 11-5.362 0 2.682 2.682 0 015.362 0"
  })))));
}

export default SvgIconWifi;